export { generalEnv, getGeneralEnvScriptContent } from './lib/libs/shared/env';
